import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-sim",
  "use": "icon-sim-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-sim\"><path d=\"M960 160H261.6c-24.5 0-48.6 7.1-69.2 20.3L58.8 266.2C22.2 289.8 0 330.3 0 373.9V800c0 35.3 28.7 64 64 64h896c35.3 0 64-28.7 64-64V224c0-35.4-28.7-64-64-64zM480 352c0-35.3 28.7-64 64-64h60c2.2 0 4 1.8 4 4v120c0 2.2-1.8 4-4 4H484c-2.2 0-4-1.8-4-4v-60z m4 96h120c2.2 0 4 1.8 4 4v120c0 2.2-1.8 4-4 4H484c-2.2 0-4-1.8-4-4V452c0-2.2 1.8-4 4-4z m60 288c-35.3 0-64-28.7-64-64v-60c0-2.2 1.8-4 4-4h120c2.2 0 4 1.8 4 4v120c0 2.2-1.8 4-4 4h-60z m96-4V292c0-2.2 1.8-4 4-4h56c2.2 0 4 1.8 4 4v440c0 2.2-1.8 4-4 4h-56c-2.2 0-4-1.8-4-4z m224-60c0 35.3-28.7 64-64 64h-60c-2.2 0-4-1.8-4-4V612c0-2.2 1.8-4 4-4h124v64z m0-96H740c-2.2 0-4-1.8-4-4V452c0-2.2 1.8-4 4-4h124v128z m0-160H740c-2.2 0-4-1.8-4-4V292c0-2.2 1.8-4 4-4h60c35.3 0 64 28.7 64 64v64z\" p-id=\"41287\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/sim.svg
// module id = Mz8m
// module chunks = 42